import { MapView } from '../features/map/MapView.js';

export function MapPage() {
  return <MapView />;
}
